{
	"backToManageDeclarations": "Zpět na Správa prohlášení"
}
